import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation, HostListener, AfterViewInit, Input, QueryList, ViewChild, NgZone, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { SlickComponent } from 'ngx-slick';
import { Expertise } from '@shared/data';

@Component({
  moduleId: 'module.id',
  selector: 'expertise-slider',
  styles: [require('./expertise-slider.component.scss')],
  template: require('./expertise-slider.component.html')
})
export class ExpertiseSliderComponent implements OnInit, AfterViewInit {
  @Input()
  public expertises: Expertise[];

  @Input()
  public lang: string;

  @Input()
  public title: string;

  @Input()
  public subtitle: string;

  @Input()
  public readMoreButton: string;

  @Input()
  public rendered: boolean;

  @Output()
  public readMoreClick: EventEmitter<void>;

  @ViewChild('slider')
  public slider: SlickComponent;

  public currentSlide: number;

  public slideCount: number;

  public config: any = {
    infinite: true,
    rows: 2,
    slidesToScroll: 1,
    slidesToShow: 1,
    slidesPerRow: 2,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          rows: 1,
          slidesToScroll: 1,
          slidesToShow: 1,
          slidesPerRow: 1,
          arrows: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          rows: 2,
          slidesToScroll: 1,
          slidesToShow: 1,
          slidesPerRow: 2,
          arrows: true
        }
      }
    ]
  };

  constructor(private zone: NgZone, private router: Router) {
    this.readMoreClick = new EventEmitter<void>();
  }

  // ===============================================================================================
  // Public Methods
  // ===============================================================================================

  public formartNumber(number: number) {
    return (number < 10 ? '0' : '') + number;
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit() {

  }

  public ngAfterViewInit() {

  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onAfterChange(evt: any) {
    this.currentSlide = evt.currentSlide;
    this.slideCount = evt.slick.slideCount - evt.slick.options.slidesToShow - 1;
  }

  public onPrev() {
    this.slider.slickPrev();
  }

  public onNext() {
    this.slider.slickNext();
  }

  public onReady() {
    this.slider.initSlick();
  }

  public onReadMoreClick(expertiseId: string) {
    this.readMoreClick.emit();
    this.router.navigate(['/expertise/', expertiseId]);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+web/modules/+home/expertise-slider/expertise-slider.component.ts